import React, { FC } from 'react';
import { ConsentsListItemProps } from './ConsentsListItem.types';
import { ConsentCheckListItem } from '../../../../molecules/ConsentCheckListItem';
import { ConsentSectionType } from '../../LegalConsents.types';

export const ConsentCheckList: FC<ConsentsListItemProps> = ({
  consentData,
  consentSectionType,
  validateErrors,
  onModalOpen,
  onCheckboxToggle,
  onLinkClickInHeaderOrCheckbox,
}) => {
  const showErrorField = validateErrors && consentSectionType === ConsentSectionType.Required;
  return (
    <>
      {consentData.checkboxes.map(checkbox => (
        <ConsentCheckListItem
          key={`checkbox-${checkbox.id}`}
          label={checkbox.label}
          errorLabel={checkbox.errorLabel}
          termsBtnLabel={checkbox.termsLinkLabel}
          termsLink={checkbox.termsLink}
          selectedConsentId={consentData.id}
          id={checkbox.id}
          className={checkbox.checkboxClassName}
          name={checkbox.name}
          isChecked={checkbox.checked}
          onModalOpen={onModalOpen}
          onChange={onCheckboxToggle}
          onLinkClickInHeaderOrCheckbox={onLinkClickInHeaderOrCheckbox}
          linkClass={checkbox.termsLinkClassName}
          linkTarget={checkbox.termsLinkTarget}
          validateErrors={showErrorField}
        />
      ))}
    </>
  );
};
